import { useCallback } from 'react';
import { isRefObject } from '../utils/assertion.esm.js';
import '../utils/ssr.esm.js';
import '../utils/number.esm.js';
import '../utils/array.esm.js';
import '../utils/breakpoint.esm.js';
import '../utils/context.esm.js';
import { contains } from '../utils/dom.esm.js';
import '../utils/tabbable.esm.js';
import { getAllFocusable } from '../utils/dom-query.esm.js';
import '../utils/logger.esm.js';
import { focus } from '../utils/focus.esm.js';
import '../utils/function.esm.js';
import '../utils/keydown.esm.js';
import '../utils/lazy.esm.js';
import '../utils/object.esm.js';
import '../utils/react-helpers.esm.js';
import '../utils/style-props.esm.js';
import '../utils/tailwind.esm.js';
import { useEventListenerV2 } from './use-event-listener-v2.esm.js';
import { useUpdateEffect } from './use-update-effect.esm.js';

var defaultOptions = {
  preventScroll: true,
  shouldFocus: false
};
function useFocusOnShow(target, options) {
  if (options === void 0) {
    options = defaultOptions;
  }

  var _options = options,
      focusRef = _options.focusRef,
      preventScroll = _options.preventScroll,
      shouldFocus = _options.shouldFocus,
      visible = _options.visible;
  var element = isRefObject(target) ? target.current : target;
  var autoFocus = shouldFocus && visible;
  var onFocus = useCallback(function () {
    if (!element || !autoFocus) return;
    if (contains(element, document.activeElement)) return;

    if (focusRef == null ? void 0 : focusRef.current) {
      focus(focusRef.current, {
        preventScroll: preventScroll,
        nextTick: true
      });
    } else {
      var tabbableEls = getAllFocusable(element);

      if (tabbableEls.length > 0) {
        focus(tabbableEls[0], {
          preventScroll: preventScroll,
          nextTick: true
        });
      }
    }
  }, [autoFocus, preventScroll, element, focusRef]);
  useUpdateEffect(function () {
    onFocus();
  }, [onFocus]);
  useEventListenerV2('transitionend', onFocus, element);
}

export { useFocusOnShow };
//# sourceMappingURL=use-focus-on-show.esm.js.map
